export default __webpack_public_path__ + "static/media/V.782bbcda.svg";